import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(true);
  const location = useLocation();
  const toggleSidebar = () => setIsOpen(!isOpen);

  // Shift the whole page so content isn't hidden behind the fixed sidebar
  useEffect(() => {
    const widthPx = isOpen ? 256 : 0; // 64 * 4 = 256px = w-64
    document.body.style.paddingLeft = `${widthPx}px`;
    document.body.style.overflowY = "auto"; // allow page scroll
    return () => {
      document.body.style.paddingLeft = "0px";
    };
  }, [isOpen]);

  const menuItems = [
    { to: "/dashboard", label: "📊 Dashboard" },
    { to: "/home-features", label: "🏠 Home Features" },
    { to: "/loan-form-effortless", label: "⚡ Loan Form Effortless" },
    { to: "/loan-step", label: "📝 Loan Step" },
    { to: "/loan-details", label: "📄 Loan Details" },
    { to: "/loan-benefits", label: "🎁 Loan Benefits" },
    { to: "/loan-criteria", label: "📌 Loan Criteria" },
    { to: "/loan-features", label: "⭐ Loan Features" },
    { to: "/loan-effortless", label: "⚡ Loan Effortless" },
    { to: "/loan-image", label: "🖼 Loan Image" },
    { to: "/talk-to-expart", label: "💬 Talk To Expart" },
    { to: "/user-details", label: "👤 User Details" },
    { to: "/career-form", label: "📑 Career Form" },
    { to: "/offer-form", label: "🎉 Offer Form" },
    { to: "/disclaimer", label: "📝 Disclaimer" },
    { to: "/terms-condition", label: "📝 Terms Condition" },
    { to: "/privacy-policy", label: "📝 Privacy Policy" },
    { to: "/business-partner", label: "📝 Business Partner" },
    { to: "/dsa-form", label: "📝 DSA Form" },
    { to: "/mission", label: "📌 Mission" },
  ];

  return (
    <>
      {isOpen && (
        <aside
          className="
            fixed top-0 left-0 h-full w-64 z-40
            bg-gradient-to-b from-gray-900 to-gray-800 text-white
            shadow-2xl transition-all duration-500 ease-in-out
            overflow-y-auto
          "
        >
          {/* Header */}
          <div className="sticky top-0 bg-gray-900/60 backdrop-blur-sm z-10 flex items-center justify-between p-4 border-b border-gray-700">
            <h2 className="text-xl font-bold tracking-wide">📂 Menu</h2>
            <button
              onClick={toggleSidebar}
              className="text-white text-lg hover:rotate-90 transform transition-transform duration-300"
              aria-label="Close sidebar"
            >
              ❌
            </button>
          </div>

          {/* Menu (scroll area handled by aside) */}
          <nav className="p-4">
            <ul className="space-y-2">
              {menuItems.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className={`block p-2 rounded-lg no-underline transition-all duration-300 hover:bg-gray-700 hover:pl-4
                      ${
                        location.pathname === item.to
                          ? "text-blue-400 font-semibold"
                          : "text-gray-300 hover:text-white"
                      }`}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </aside>
      )}

      {!isOpen && (
        <button
          onClick={toggleSidebar}
          className="fixed top-4 left-4 z-40 bg-gray-900 text-white text-2xl p-2 rounded-lg shadow-lg hover:bg-gray-700 transition-all"
          aria-label="Open sidebar"
        >
          ☰
        </button>
      )}
    </>
  );
};

export default Sidebar;
